/**
 * Where the app lands after sign-in, onboarding, `/` and the sidebar logo.
 * The Pipeline route itself sends orgs without the Jobs feature on to
 * `/dashboard`, so they still land where they always have.
 */
export const APP_HOME_PATH = '/pipeline' as const
